import {
	PropositionFiltersDto,
	PropositionProductType,
	PropositionProductTypeValues,
	PropositionStatus,
	PropositionStatusValues,
} from "@dune/types";
import { useCallback, useMemo } from "react";
import { useSearchParams } from "react-router-dom";

export const usePropositionFilters = () => {
	const [searchParams, setSearchParams] = useSearchParams();

	const filters = useMemo((): PropositionFiltersDto => {
		const status = searchParams.get("status") as PropositionStatusValues | null;
		const productType = searchParams.get(
			"productType",
		) as PropositionProductTypeValues | null;
		const constructionSiteId = searchParams.get("constructionSiteId");
		const brokerSocietyId = searchParams.get("brokerSocietyId");
		const search = searchParams.get("search");
		const page = searchParams.get("page");
		const limit = searchParams.get("limit");
		const sortBy = searchParams.get("sortBy");
		const sortOrder = searchParams.get("sortOrder") as "asc" | "desc" | null;

		return {
			...(status && { status }),
			...(productType && { productType }),
			...(constructionSiteId && {
				constructionSiteId: Number(constructionSiteId),
			}),
			...(brokerSocietyId && { brokerSocietyId: Number(brokerSocietyId) }),
			...(search && { search }),
			...(page && { page: Number(page) }),
			...(limit && { limit: Number(limit) }),
			...(sortBy && { sortBy }),
			...(sortOrder && { sortOrder }),
		};
	}, [searchParams]);

	const updateFilters = useCallback(
		(newFilters: Partial<PropositionFiltersDto>) => {
			const params = new URLSearchParams(searchParams);

			for (const [key, value] of Object.entries(newFilters)) {
				if (value !== undefined && value !== null && value !== "") {
					params.set(key, String(value));
				} else {
					params.delete(key);
				}
			}

			setSearchParams(params);
		},
		[searchParams, setSearchParams],
	);

	const clearFilters = useCallback(() => {
		setSearchParams({});
	}, [setSearchParams]);

	return {
		filters,
		updateFilters,
		clearFilters,
		hasActiveFilters: Object.keys(filters).length > 0,
	};
};

export const usePropositionStatusOptions = () => {
	return useMemo(
		() => [
			{ value: PropositionStatus.NOUVEAU, label: "Nouveau" },
			{ value: PropositionStatus.A_SIGNER, label: "À signer" },
			{ value: PropositionStatus.SIGNEE, label: "Signée" },
			{ value: PropositionStatus.SANS_SUITE, label: "Sans suite" },
		],
		[],
	);
};

export const usePropositionProductTypeOptions = () => {
	return useMemo(
		() => [
			{ value: PropositionProductType.DO, label: "Dommages Ouvrage" },
			{ value: PropositionProductType.TRC, label: "TRC" },
			{ value: PropositionProductType.MRT, label: "MRT" },
			{ value: PropositionProductType.GFA, label: "GFA" },
		],
		[],
	);
};
